export default __webpack_public_path__ + "static/media/HealthProfile.c3cf0e07.jpg";